import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AccountDataStoreModule } from '@recruitee/account/data';

import { AccountStoreModule } from './store/account-store.module';
import { WS_URL } from './tokens';

@NgModule({
  imports: [CommonModule, AccountStoreModule, AccountDataStoreModule],
})
export class AccountModule {
  public static forRoot(wsUrl: string): ModuleWithProviders<AccountStoreModule> {
    return {
      ngModule: AccountStoreModule,
      providers: [{ provide: WS_URL, useValue: wsUrl }],
    };
  }
}
